import { type FC, type ReactNode } from 'react';
import styles from './NftSearchBarSection.scss';

type Props = {
    title: ReactNode;
    children: ReactNode;
};

export const NftSearchBarSection: FC<Props> = ({ title, children }) => {
    return (
        <div data-tn="search-bar-section" className={styles.section}>
            <div data-tn="search-bar-header" className={styles.header}>
                {title}
            </div>
            {children}
        </div>
    );
};
